import { usePadding } from "@/components/utils/Padding";
import { EyebrowPropTypes } from "./propTypes";
import "./styles.scss";

const Eyebrow = (props) => {
  const {
    display_eyebrow: displayEyebrow,
    display_eyebrow_order: displayEyebrowOrder,
    eyebrow_content: eyebrowContent,
    eyebrow_order: eyebrowOrder,
    eyebrow_padding: eyebrowPadding,
  } = props;

  const paddingStyle = usePadding(eyebrowPadding);

  if (!displayEyebrow || !eyebrowContent) {
    return null;
  }

  const eyebrowStyle = {
    ...(displayEyebrowOrder && { order: eyebrowOrder || 0 }),
    ...paddingStyle,
  };

  return (
    <div
      className="eyebrow-component"
      style={eyebrowStyle}
      dangerouslySetInnerHTML={{ __html: eyebrowContent }}
    />
  );
};

Eyebrow.propTypes = EyebrowPropTypes;

export default Eyebrow;
